import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { apiErrorLogger, apiInfoLogger } from '@/lib/monitoring/api-logger';
import { UserAuthApiService } from '@/services/internal-api/user-auth/user-auth-api-service';
import type { SignupPayload } from '@/services/internal-api/user-auth/types/user-auth-api-service-types';

export function useAuthSignup() {
  const { status, isSuccess, isError, isLoading, error, mutate, mutateAsync, data } = useMutation({
    mutationFn: (payload: SignupPayload) => UserAuthApiService.signup(payload),
    onSuccess: res => {
      apiInfoLogger('Auth signup successful', 'useAuthSignup', res);
    },
    onError: (error: AxiosError<any>) => {
      apiErrorLogger('Auth signup failed', 'useAuthSignup', error);
    },
  });

  return {
    status,
    isSuccess,
    isError,
    isLoading,
    error,
    mutate,
    mutateAsync,
    data,
  };
}
